import { svg } from 'util/svg';
import playIcon from 'images/icons/play.svg';

export const addPlayIcon = $video => {
  const $button = svg(playIcon, 'c-video__play');
  $video.appendChild($button);
};
